import { createSlice } from "@reduxjs/toolkit";

import { fetchGetVdaActionDefinitions } from "./actions";
import { DataStatus } from "../../types";

type VdaActionDefinitionsState = {
  data: Array<VdaActionDefinition>;
  status: DataStatus;
  error: string | null;
};

const initialState: VdaActionDefinitionsState = {
  data: [],
  status: DataStatus.idle,
  error: null,
};

export const Slice = createSlice({
  name: "vdaActionDefinitions",
  initialState,
  reducers: {
    resetVdaActionDefinitions: () => initialState,
    setVdaActionDefinitions: (state, { payload }) => {
      state.data = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetVdaActionDefinitions.pending, (state) => {
        state.status = DataStatus.loading;
        state.error = null;
      })
      .addCase(fetchGetVdaActionDefinitions.fulfilled, (state, action) => {
        state.status = DataStatus.succeeded;
        state.data = action.payload;
      })
      .addCase(fetchGetVdaActionDefinitions.rejected, (state, action) => {
        state.status = DataStatus.failed;
        state.error = action.error.message ?? "";
      });
  },
});

export default Slice;
